exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._-_-src-components-Chat-___chatTabs__chatTabs___DMcmb{display:-ms-flexbox;display:flex;border-radius:5px 5px 0 0;border-bottom:1px solid #ced9eb;height:55px}", ""]);

// exports
exports.locals = {
	"chatTabs": "_-_-src-components-Chat-___chatTabs__chatTabs___DMcmb"
};


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!/var/www/build-health-2/~/postcss-loader!/var/www/build-health-2/src/components/Chat/chatTabs.css
// module id = 1351
// module chunks = 0